var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},_vm._l((_vm.imgList),function(img){return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(img),expression:"img"}],key:img})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }